<template>
  <div class="col">
    <slot></slot>
  </div>
</template>

<script>
  import 'jquery-validation'
  import autosize from 'autosize'
  import 'flatpickr'
  import 'flatpickr/dist/flatpickr.min.css'
  import { Spanish } from 'flatpickr/dist/l10n/es'
  import moment from 'moment'
  
  export default {
    name: 'UserSiiLevel',
    mounted () {
      autosize($('textarea'))
      
      const $startDate = $('#start_date')
      const $endDate   = $('#end_date')
      
      /**
       * Apply date pickers.
       **/
      const vm = this
      
      $startDate.flatpickr({
        disableMobile: false,
        dateFormat: 'd/m/Y',
        locale: Spanish,
        onChange (dates, dateStr, instance) {
          const date = moment(dates[0]).add(1, 'd').format('DD/MM/YYYY')
          vm.endDate.set('minDate', date)
        },
      })
      
      $endDate.flatpickr({
        disableMobile: false,
        dateFormat: 'd/m/Y',
        locale: Spanish,
      })
      
      this.starDate = $startDate.get(0)._flatpickr
      this.endDate  = $endDate.get(0)._flatpickr
      
      $(this.$el).find('form').removeClass('invisible').validate({
        ignore: [],
        highlight: function (element, errorClass, validClass) {
          $(element).addClass('is-invalid')
        },
        unhighlight: function (element, errorClass, validClass) {
          $(element).removeClass('is-invalid')
        },
        errorPlacement: function (label, element) {
          label.addClass('invalid-feedback')
          label.insertAfter(element)
        },
        rules: {
          start_date: {
            required: true,
          },
          end_date: {
            required: true,
          },
          requested_level: {
            required: true,
          },
          level_id: {
            required: true,
          },
        },
        messages: {
          start_date: {
            required: 'Seleccione la fecha de inicio.',
          },
          end_date: {
            required: 'Seleccione la fecha de término.',
          },
          requested_level: {
            required: 'Seleccione el nivel solicitado',
          },
          level_id: {
            required: 'Seleccione el nivel obtenido',
          },
        },
        submitHandler (form) {
          $('#btn-save, #btn-cancel').prop('disabled', true)
          $('#btn-save').find('.spinner-border').removeClass('d-none')
          
          $('#btn-cancel').addClass('disabled')
          
          form.submit()
        },
      })
    },
  }
</script>
